(() => {
  const boot = () => {
    document.querySelectorAll('[data-fwl1]:not([data-fwl1-ready])').forEach(init);
  };

  const init = (root) => {
    root.dataset.fwl1Ready = 'true';

    const state = new Map();
    const cards = [...root.querySelectorAll('[data-fwl1-item]')];
    const currency = root.dataset.currency || 'USD';
    const routesRoot = window.Shopify?.routes?.root || '/';
    const codes = {
      12: root.dataset.code12 || 'L1BUILD12',
      15: root.dataset.code15 || 'L1BUILD15'
    };

    const els = {
      sizes: [...root.querySelectorAll('[data-fwl1-size]')],
      sizeCounts: [...root.querySelectorAll('[data-fwl1-size-count]')],
      tabs: [...root.querySelectorAll('[data-fwl1-tab]')],
      panels: [...root.querySelectorAll('[data-fwl1-panel]')],
      capNote: root.querySelector('[data-fwl1-cap-note]'),
      meter: root.querySelector('[data-fwl1-meter]'),
      meterTitle: root.querySelector('[data-fwl1-meter-title]'),
      meterValue: root.querySelector('[data-fwl1-meter-value]'),
      meterTrack: root.querySelector('[data-fwl1-meter-track]'),
      meterFill: root.querySelector('[data-fwl1-meter-fill]'),
      meterCount: root.querySelector('[data-fwl1-meter-count]'),
      meterNext: root.querySelector('[data-fwl1-meter-next]'),
      summary: root.querySelector('[data-fwl1-summary]'),
      subtotal: root.querySelector('[data-fwl1-subtotal]'),
      saleSavingRow: root.querySelector('[data-fwl1-sale-saving-row]'),
      saleSaving: root.querySelector('[data-fwl1-sale-saving]'),
      filterSavingRow: root.querySelector('[data-fwl1-filter-saving-row]'),
      filterSavingLabel: root.querySelector('[data-fwl1-filter-saving-label]'),
      filterSaving: root.querySelector('[data-fwl1-filter-saving]'),
      total: root.querySelector('[data-fwl1-total]'),
      add: root.querySelector('[data-fwl1-add]'),
      status: root.querySelector('[data-fwl1-status]')
    };

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency
        }).format((Number(cents) || 0) / 100);
      } catch (_) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    };

    const dataFor = (card) => ({
      id: String(card.dataset.id || ''),
      productId: String(card.dataset.productId || ''),
      title: card.dataset.title || 'Product',
      role: card.dataset.role || 'filter',
      size: card.dataset.size || '',
      price: Number(card.dataset.price || 0),
      compare: Number(card.dataset.compare || 0),
      available: card.dataset.available === 'true',
      includes: String(card.dataset.includes || '').split(',').map(value => value.trim()).filter(Boolean),
      quantity: 0
    });

    const selectedItems = () => [...state.values()].filter(item => item.quantity > 0);

    const includedMap = () => {
      const map = new Map();
      selectedItems().filter(item => item.role === 'kit').forEach(kit => {
        kit.includes.forEach(id => {
          if (!map.has(id)) map.set(id, { quantity: 0, setups: 0 });
          const inclusion = map.get(id);
          inclusion.quantity += kit.quantity;
          inclusion.setups += 1;
        });
      });
      return map;
    };

    const metrics = () => {
      const all = selectedItems();
      const kits = all.filter(item => item.role === 'kit');
      const filters = all.filter(item => item.role === 'filter');
      const filterUnits = filters.reduce((sum, item) => sum + item.quantity, 0);
      const percent = filterUnits >= 2 ? 15 : (kits.length && filterUnits === 1 ? 12 : 0);
      const subtotal = all.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const filterSubtotal = filters.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const compareTotal = all.reduce((sum, item) => {
        const compare = item.compare > item.price ? item.compare : item.price;
        return sum + compare * item.quantity;
      }, 0);
      const saleSaving = Math.max(0, compareTotal - subtotal);
      const filterSaving = percent ? Math.round(filterSubtotal * percent / 100) : 0;
      return {
        all,
        kits,
        filterUnits,
        percent,
        subtotal,
        saleSaving,
        filterSaving,
        total: Math.max(0, subtotal - filterSaving)
      };
    };

    const meterCopy = (current) => {
      const count = current.filterUnits
        ? `${current.filterUnits} extra filter${current.filterUnits === 1 ? '' : 's'} selected`
        : 'No extra filters selected';

      if (current.filterUnits >= 2) {
        return {
          stage: 'max',
          title: 'Maximum filter savings unlocked',
          value: '15% OFF',
          count,
          next: `You save ${money(current.filterSaving)} on filters.`
        };
      }

      if (current.percent === 12) {
        return {
          stage: 'unlocked',
          title: 'Filter savings unlocked',
          value: '12% OFF',
          count,
          next: `Save ${money(current.filterSaving)} · Add 1 more filter for 15%.`
        };
      }

      if (current.filterUnits === 1) {
        return {
          stage: 'ready',
          title: 'One filter selected',
          value: '0% UNLOCKED',
          count,
          next: current.kits.length ? 'Add 1 more filter for 15% off.' : 'Add a kit for 12%, or 1 more filter for 15%.'
        };
      }

      return {
        stage: 'locked',
        title: 'Add a kit and one filter for 12% off',
        value: '0% UNLOCKED',
        count,
        next: '1 filter + kit = 12% off · 2 filters = 15% off'
      };
    };

    const selectSize = (requestedSize) => {
      const allowed = els.sizes.map(button => String(button.dataset.fwl1Size || '')).filter(Boolean);
      const size = allowed.includes(String(requestedSize)) ? String(requestedSize) : '';
      root.dataset.selectedSize = size;

      els.sizes.forEach(button => {
        const active = button.dataset.fwl1Size === size;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      cards.forEach(card => {
        const role = card.dataset.role || '';
        if (role !== 'ring' && role !== 'ring-cap') return;
        card.hidden = !size || card.dataset.size !== size;
      });
    };

    const selectTab = (requestedTab) => {
      const tab = els.tabs.some(button => button.dataset.fwl1Tab === requestedTab)
        ? requestedTab
        : 'control';

      els.tabs.forEach(button => {
        const active = button.dataset.fwl1Tab === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      els.panels.forEach(panel => {
        const active = panel.dataset.fwl1Panel === tab;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    const setQuantity = (card, next) => {
      const item = dataFor(card);
      if (!item.id || !item.available) return;

      const quantity = Math.max(0, Math.min(99, Number(next) || 0));
      if (!quantity) {
        state.delete(item.id);
      } else {
        item.quantity = quantity;
        state.set(item.id, item);
      }
      render();
    };

    const render = () => {
      const current = metrics();
      const included = includedMap();
      const sizeCounts = new Map();
      let ringOnlyUnits = 0;

      current.all.forEach(item => {
        if ((item.role === 'ring' || item.role === 'ring-cap') && item.size) {
          sizeCounts.set(item.size, (sizeCounts.get(item.size) || 0) + item.quantity);
        }
        if (item.role === 'ring') ringOnlyUnits += item.quantity;
      });

      els.sizeCounts.forEach(node => {
        const count = sizeCounts.get(node.dataset.fwl1SizeCount) || 0;
        node.hidden = count === 0;
        node.textContent = String(count);
      });

      cards.forEach(card => {
        const id = String(card.dataset.id || '');
        const selected = state.get(id);
        const quantity = selected?.quantity || 0;
        const inclusion = included.get(id);
        const includedQuantity = inclusion?.quantity || 0;
        const isIncluded = includedQuantity > 0;
        const toggle = card.querySelector('[data-fwl1-toggle]');
        const minus = card.querySelector('[data-fwl1-minus]');
        const plus = card.querySelector('[data-fwl1-plus]');
        const output = card.querySelector('[data-fwl1-qty]');
        const cardState = card.querySelector('[data-fwl1-state]');
        const note = card.querySelector('[data-fwl1-included]');

        card.classList.toggle('is-selected', quantity > 0);
        card.classList.toggle('is-included', isIncluded);

        if (toggle) {
          toggle.setAttribute('aria-pressed', quantity > 0 ? 'true' : 'false');
          toggle.disabled = card.dataset.available !== 'true';
        }
        if (minus) minus.disabled = quantity <= 0;
        if (plus) plus.disabled = card.dataset.available !== 'true' || quantity >= 99;
        if (output) output.textContent = String(quantity);

        if (cardState) {
          cardState.textContent = isIncluded
            ? (quantity ? `${quantity} extra selected` : `${includedQuantity} included`)
            : (quantity ? 'Added' : (card.dataset.available === 'true' ? 'Add' : 'Sold out'));
        }

        if (note) {
          note.hidden = !isIncluded;
          if (isIncluded) {
            const setupWord = inclusion.setups === 1 ? 'kit' : 'kits';
            const extraText = includedQuantity === 1
              ? 'Use + if you want another.'
              : 'Use + if you want more.';
            note.textContent = `Already included with your selected ${setupWord}. ${extraText}`;
          } else {
            note.textContent = '';
          }
        }
      });

      if (els.capNote) {
        els.capNote.hidden = ringOnlyUnits === 0;
        els.capNote.textContent = ringOnlyUnits === 1
          ? 'This Base Ring does not include a cap. Choose Base Ring + Cap when you want both parts.'
          : 'These Base Rings do not include caps. Choose Base Ring + Cap when you want both parts.';
      }

      const meter = meterCopy(current);
      if (els.meter) els.meter.dataset.stage = meter.stage;
      if (els.meterTitle) els.meterTitle.textContent = meter.title;
      if (els.meterValue) els.meterValue.textContent = meter.value;
      if (els.meterCount) els.meterCount.textContent = meter.count;
      if (els.meterNext) els.meterNext.textContent = meter.next;
      if (els.meterTrack) els.meterTrack.setAttribute('aria-valuenow', String(Math.min(2, current.filterUnits)));
      if (els.meterFill) els.meterFill.style.width = `${Math.min(2, current.filterUnits) * 50}%`;

      if (els.summary) els.summary.hidden = current.all.length === 0;
      if (els.subtotal) els.subtotal.textContent = money(current.subtotal);
      if (els.saleSavingRow) els.saleSavingRow.hidden = current.saleSaving === 0;
      if (els.saleSaving) els.saleSaving.textContent = `−${money(current.saleSaving)}`;
      if (els.filterSavingRow) els.filterSavingRow.hidden = current.filterSaving === 0;
      if (els.filterSavingLabel) els.filterSavingLabel.textContent = `${current.percent}% filter savings`;
      if (els.filterSaving) els.filterSaving.textContent = `−${money(current.filterSaving)}`;
      if (els.total) els.total.textContent = money(current.total);
      if (els.add) els.add.disabled = current.all.length === 0;
    };

    els.sizes.forEach(button => {
      button.addEventListener('click', () => selectSize(button.dataset.fwl1Size));
    });

    els.tabs.forEach(button => {
      button.addEventListener('click', () => selectTab(button.dataset.fwl1Tab));
    });

    cards.forEach(card => {
      card.querySelector('[data-fwl1-toggle]')?.addEventListener('click', () => {
        const current = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, current ? 0 : 1);
      });

      card.querySelector('[data-fwl1-minus]')?.addEventListener('click', () => {
        const current = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, current - 1);
      });

      card.querySelector('[data-fwl1-plus]')?.addEventListener('click', () => {
        const current = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, current + 1);
      });
    });

    const pageVariant = String(root.dataset.currentVariant || '');
    const pageCard = pageVariant ? cards.find(card => String(card.dataset.id || '') === pageVariant) : null;
    const pagePanel = pageCard?.closest('[data-fwl1-panel]');
    const initialTab = pagePanel?.dataset.fwl1Panel || 'control';
    if (pageCard && pageCard.dataset.available === 'true') {
      const item = dataFor(pageCard);
      item.quantity = 1;
      state.set(item.id, item);
      if (item.size) selectSize(item.size);
    } else {
      selectSize(root.dataset.selectedSize || '');
    }
    selectTab(initialTab);

    const cartQuantities = (cart) => {
      const quantities = new Map();
      (cart.items || []).forEach(item => {
        const id = String(item.variant_id || item.id || '');
        quantities.set(id, (quantities.get(id) || 0) + Number(item.quantity || 0));
      });
      return quantities;
    };

    els.add?.addEventListener('click', async () => {
      const current = metrics();
      if (!current.all.length) return;

      els.add.disabled = true;
      els.add.textContent = 'Adding and checking your setup…';
      if (els.status) els.status.textContent = '';

      try {
        const beforeResponse = await fetch(`${routesRoot}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!beforeResponse.ok) throw new Error('The cart could not be checked. Please refresh and try again.');
        const before = cartQuantities(await beforeResponse.json());

        const items = current.all.map(item => ({
          id: Number(item.id),
          quantity: item.quantity
        }));

        const response = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || result.message || 'Some products could not be added.');

        const afterResponse = await fetch(`${routesRoot}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!afterResponse.ok) throw new Error('Your cart could not be verified. Please open the cart and check the items.');
        const after = cartQuantities(await afterResponse.json());

        const missing = items.filter(item => {
          const id = String(item.id);
          return (after.get(id) || 0) < (before.get(id) || 0) + item.quantity;
        });
        if (missing.length) throw new Error('Some items were not confirmed in the cart. Please refresh and try again.');

        const code = current.percent ? codes[current.percent] : '';
        if (code) {
          window.location.assign(`${routesRoot}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${routesRoot}cart`)}`);
        } else {
          window.location.assign(`${routesRoot}cart`);
        }
      } catch (error) {
        if (els.status) els.status.textContent = error.message || 'Please try again.';
        els.add.disabled = false;
        els.add.textContent = 'Add selected items to cart';
      }
    });

    render();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
